import { useContext } from "react";
import UserContext from "./userSettings";

export default () => {
  const context = useContext(UserContext);

  return context;
};